import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { FormattedMessage, useIntl } from "react-intl";
import FullNav from "./full-nav";
import Link from "./link";
import Logo from "./logo";
import ButtonLink from "./button-link";
import SocialNetworks from "./social-networks";
import Ultro from "./ultro";
import GoogleRating from "./google-rating";
import { GatsbyImage } from "gatsby-plugin-image";

const query = graphql`
  query {
    homePages: allContentfulHome(
      filter: { contentful_id: { eq: "62rvf78k5yrgR3aq2foZ58" } }
    ) {
      nodes {
        node_locale
        footerLogos {
          contentful_id
          title
          gatsbyImageData(quality: 80)
        }
      }
    }
    pages: allContentfulPage {
      nodes {
        node_locale
        contentful_id
        title
        slug
      }
    }
    allContentfulLink(
      filter: {
        metadata: {
          tags: { elemMatch: { name: { eq: "downloadCatalogFooter" } } }
        }
      }
    ) {
      nodes {
        node_locale
        id
        button
        buttonBackgroundColour
        target
        textColour
        title
        link
        modal {
          ...Modal
        }
      }
    }
  }
`;

const ContactText = () => {
  const { locale } = useIntl();

  if (locale === "en") {
    return (
      <p>
        Any questions about our adventures? Contact us via{" "}
        <Link href="/contact/">this form</Link> or give us a call at{" "}
        <a href="tel:+33189315582">+33 1 89 31 55 82</a>.
      </p>
    );
  }

  return (
    <p>
      Une question sur nos aventures ? Contactez-nous via{" "}
      <Link href="/contact/">notre formulaire</Link> ou appelez-nous au{" "}
      <a href="tel:+33189315582">+33 1 89 31 55 82</a>.
    </p>
  );
};

const Footer = () => {
  const { homePages, pages, allContentfulLink } = useStaticQuery(query);
  const { locale, formatMessage } = useIntl();
  const isActiveLocale = ({ node_locale }) => node_locale === locale;
  const newsletter = formatMessage({ id: "newsletterIntro" });
  const { footerLogos } = homePages.nodes.find(isActiveLocale);

  const getPageById = (id) => {
    const isId = ({ contentful_id }) => contentful_id === id;
    return pages.nodes.filter(isActiveLocale).find(isId);
  };

  const downloadButton = allContentfulLink.nodes.find(
    (item) => item.node_locale === locale
  );

  const privacyPage = getPageById("4MqaAmsD225xUL2r4LOWwj");
  const termsPage = getPageById("4P2nU7ECuj4yDCBZDGPhcU");

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-contact">
            <p>
              <strong>Contact</strong>
            </p>
            <ContactText />
          </div>
          <div id="newsletter" className="footer-newsletter">
            <p>
              <strong>
                <FormattedMessage id="newsletterFooterTitle" />
              </strong>
            </p>
            <p dangerouslySetInnerHTML={{ __html: newsletter }} />
            <div>
              {downloadButton && (
                <ButtonLink
                  href={downloadButton.link}
                  backgroundColor={downloadButton.buttonBackgroundColour}
                  textColor={downloadButton.textColour}
                  button={downloadButton.button}
                  target={downloadButton.target}
                  modal={downloadButton.modal}
                >
                  {downloadButton.title}
                </ButtonLink>
              )}
              <SocialNetworks />
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-logos">
            <div>
              <Link href="/">
                <Logo />
              </Link>
              <GoogleRating variant="wrap" />
            </div>
            <div>
              {footerLogos.map((logo) => (
                <figure key={logo.contentful_id}>
                  <GatsbyImage image={logo.gatsbyImageData} alt={logo.title} />
                </figure>
              ))}
            </div>
          </div>
          <FullNav />
          <div className="footer-credits">
            <p>
              <span>&copy; Copyright {new Date().getFullYear()}</span>{" "}
              {privacyPage && (
                <>
                  <Link href={`/${privacyPage.slug}/`}>
                    {privacyPage.title}
                  </Link>{" "}
                </>
              )}
              {termsPage && (
                <Link href={`/${termsPage.slug}/`}>{termsPage.title}</Link>
              )}
              <span>
                <FormattedMessage id="footerCredits" />{" "}
                <a href="https://ultro.fr" target="_blank" rel="noreferrer">
                  <Ultro />
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
